import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-create-size',
  templateUrl: './create-size.component.html',
  styleUrls: ['./create-size.component.scss'],
})
export class CreateSizeComponent {
  loader: boolean = false;
  name;
  editBool: boolean = false;
  id;
  item: any;
  activeInd: boolean = true;
  category;
  cateName;
  cateId;
  qty;
  fontStyle;
  serviceTypeObj = [{ id: 1, name: "Org Service" },
  { id: 3, name: "Ads Service" }];
  serviceTypeId: any = 1;
  serviceTypeName: any = "Org Service";
  pic: any;
  data: any;
  productName;
productId;
productObj:any;
  description;
  code;
  constructor(public service: ApiService,
    public handler: HandlerService,
    private bottomSheet: MatBottomSheet,
    public router: Router) { }

  ionViewWillEnter() {
    this.fontStyle = localStorage.getItem('lang')
    let url = window.location.href;
    this.id = window.location.href.split('/').pop();

    if (url.includes('edit')) {
      this.editBool = true;
      this.id = window.location.href.split('/').pop();
      this.service.getsizeById(this.id).subscribe((res: any) => {
        this.item=res;
        this.name = res.name;
        this.code = res.code;
        this.activeInd = res.activeInd;
        this.cateId=res.purchaseCategoryId;
        this.productId-res.productId;
        setTimeout(() => {
          this.category.map(res1 => {
            if (res1.id == this.cateId) {
              this.cateName = res1.name;
              this.cateId = res1.id;
            }
          })
        }, 1000);
          },
        err => {
          this.handler.err(err);
          this.loader = false;
        })

    }
    else {
      this.editBool = false;
    }
   
    this.getProductObject();
    this.getCategory();
  }

  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.category.map(dat=>{
        if(dat.id==this.cateId){
          this.cateName = dat.name;
        }
      })
      this.loader=false;
    })
  }
  
  openBottomSheet(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;  
        }
    });
  }

  getProductObject(){
    this.service.getAllProduct().subscribe(res => {
      this.productObj = res;
      this.productObj.map(dat=>{
        if(dat.id==this.productId){
         this.productName = dat.name
        }
      }) 
      
    })
  }

    openBottomSheetProduct() {
      this.productObj=this.productObj.filter(res=>{return this.cateId==res.purchaseCategory})
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.productObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.productName = res.name;
          this.productId = res.id;
        }
      });
    }

  create() {
    if(this.cateId && this.productId){
    this.loader = true;
    var post = {
      "name": this.name,
      "code": this.code,
      "activeInd": true,
      "purchaseCategoryId":this.cateId,
      "productId":this.productId
    }

    this.service.createsize(post).subscribe(res => {
      this.handler.res("Size Created Successfully");
      this.loader = false;
      this.router.navigate(['manage-size'])

    },
      err => {
        this.loader = false;
        this.handler.err(err);

      })
    }else{
      this.handler.err('Please Enter Required Fields')
    }
  }
  editsize() {
    if(this.cateId && this.productId){
    this.loader = true;
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    this.item.name = this.name;
    this.item.code = this.code;
    this.item.activeInd = this.activeInd;    
    this.item.purchaseCategoryId = this.cateId;
    this.item.productId = this.productId;    
    this.service.updatesize(this.id, this.item).subscribe(res => {
      this.loader = false;
      this.handler.res("Size Updated Successfully");
      this.router.navigate(['manage-size'])
    },
      err => {
        this.loader = false;
        this.handler.err(err);

      })
    }else{
      this.handler.err('Please Enter Required Fields')
    }
  }
  cancel() {
    this.router.navigate(['/manage-size']);
  }
  ionViewWillLeave() {
    this.editBool=false;
  }
 
}





